import React, { useState } from 'react';

const DropdownInput = ({ title, options, selectedOption, setSelectedOption }) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div className="column is-one-fifth">
      <div className="field">
        <div className="label">
          <label htmlFor="" className="label">{title}</label>
        </div>
        <div className="field-body">
          <div className="field">
            <div className={`dropdown ${isActive && 'is-active'}`}>
              <div className="dropdown-trigger">
                <button className="button" aria-haspopup="true" aria-controls="dropdown-menu" onClick={() => setIsActive(!isActive)}>
                  <span>{selectedOption ? selectedOption : 'Seleccionar una opcion'}</span>
                  <span className="icon is-small">
                    <i className="fas fa-angle-down" aria-hidden="true"></i>
                  </span>
                </button>
              </div>
              <div className="dropdown-menu" id="dropdown-menu" role="menu">
                <div className="dropdown-content">
                  {options.map((option, index) =>
                    <a key={index} href="" className="dropdown-item" onClick={(e) => {
                      e.preventDefault();
                      setSelectedOption(option);
                      setIsActive(false);
                    }}>
                      {option}
                    </a>
                  )}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DropdownInput;